module.exports = __webpack_public_path__ + "static/media/steps-image.e4189bf1.svg";